import { Link } from "react-router-dom";
import { Cross } from "lucide-react";
import { LandingFooter } from "@/components/LandingFooter";
import { PlanCards } from "@/components/PlanCards";

export default function Pricing() {
  return <div className="min-h-screen bg-white">
    <header className="border-b border-gray-100"><div className="max-w-5xl mx-auto px-5 py-5 flex justify-between items-center gap-3">
      <Link data-testid="pricing-home" to="/" className="font-head font-extrabold flex items-center gap-2"><Cross className="w-6 h-6 text-emerald-600" />FarmaPresenze</Link>
      <Link data-testid="pricing-login" to="/accedi" className="text-sm text-emerald-700 font-semibold">Accedi</Link>
    </div></header>
    <main className="max-w-5xl mx-auto px-5 py-12 sm:py-16">
      <p className="text-sm font-semibold text-emerald-700">30 giorni per provarlo, senza addebiti.</p>
      <h1 data-testid="pricing-title" className="font-head text-4xl sm:text-5xl lg:text-6xl font-extrabold mt-3">Il prezzo è chiaro.<br />Fin dal primo giorno.</h1>
      <p data-testid="pricing-summary" className="mt-5 text-gray-600 max-w-2xl">Carta richiesta all'attivazione, 0,00€ oggi. Poi 29€/mese o 290€/anno. Disdetta gratuita dalla dashboard prima della fine della prova.</p>
      <PlanCards />
    </main><LandingFooter />
  </div>;
}